import React from 'react';

export type LayoutBackground = 'white' | 'neutral-1' | 'gradient';

export interface LayoutProps {
  variant?: LayoutVariant | 'default' | 'fullWidth';
  background?: LayoutBackground;
  className?: string;
  children?: React.ReactNode;
  headerSlot?: React.ReactNode;
  hasBorder?: boolean;
  noFooterSpace?: boolean;
  projectName?: string;
}
/**
 * @deprecated
 */
export enum LayoutVariant {
  Default = 'default',
  FullWidth = 'fullWidth',
}
